import { all } from "redux-saga/effects";
import { chuyenNganhSaga } from "./chuyenNganhSaga";
import { keHoachNamSaga } from "./keHoachNamSaga";
import { loaiThuChiSaga } from "./loaiThuChiSaga";
import { mucHocPhiTinChiSaga } from "./mucHocPhiTinChiSaga";
import { heSaga } from "./heSaga";
import { lopNamHocSaga } from "./lopNamHocSaga";
import { nhomLoaiThuChiSaga } from "./nhomLoaiThuChiSaga";
import { hinhThucNopTienSaga } from "./hinhThucNopTienSaga";
import { hocKyDangKySaga } from "./hocKyDangKySaga";
import { khoaSaga } from "./khoaSaga";
import { bienLaiThietLapSaga } from "./bienLaiThietLapSaga";
import { loaiThuNhapHocSaga } from "./loaiThuNhapHocSaga";
import { coSoSaga } from "./coSoSaga";
import { khoiNganhSaga } from "./khoiNganhSaga";
import { loaiThuTuyenSinhSaga } from "./loaiThuTuyenSinhSaga";
import { dotTuyenSinhSaga } from "./dotTuyenSinhSaga";
import { nganhSaga } from "./nganhSaga";
import { voucherSaga } from "./voucherSaga";
import { configInvoiceSaga } from "./configInvoiceSaga";
import { trangThaiHocSaga } from "./trangThaiHocSaga";
import { tsNganhXetTuyenSaga } from "./tsNganhXetTuyenSaga";
import { quocTichSaga } from "./quocTichSaga";
import { danhBaSinhVienSaga } from "./danhBaSinhVienSaga";
import { doiTuongKhongTinhHocPhiSaga } from "./doiTuongKhongTinhHocPhiSaga";
import { monKhongTinhHocPhiSaga } from "./monKhongTinhHocPhiSaga";
import { monHocSaga } from "./monHocSaga";

export default function* categorySagaWrapper() {
  yield all([
    loaiThuChiSaga(),
    mucHocPhiTinChiSaga(),
    nganhSaga(),
    chuyenNganhSaga(),
    keHoachNamSaga(),
    heSaga(),
    lopNamHocSaga(),
    nhomLoaiThuChiSaga(),
    hinhThucNopTienSaga(),
    hocKyDangKySaga(),
    khoaSaga(),
    bienLaiThietLapSaga(),
    loaiThuNhapHocSaga(),
    coSoSaga(),
    khoiNganhSaga(),
    loaiThuTuyenSinhSaga(),
    dotTuyenSinhSaga(),
    voucherSaga(),
    configInvoiceSaga(),
    trangThaiHocSaga(),
    tsNganhXetTuyenSaga(),
    quocTichSaga(),
    danhBaSinhVienSaga(),
    doiTuongKhongTinhHocPhiSaga(),
    monKhongTinhHocPhiSaga(),
    monHocSaga(),
  ]);
}
